import ajax from '@/libs/Ajax'

export default {
    queryMouldList(params) {
        return ajax.get('/aseapi/console/sysmgr/mouldmgr/listJsonMould', {params: params})
    },

    saveMould(data) {
        return ajax.post('/aseapi/console/sysmgr/mouldmgr/saveJsonMould', data)
    },
    updateJsonMould(data) {
        return ajax.post('/aseapi/console/sysmgr/mouldmgr/updateJsonMould', data)
    },

    delMould(params) {
        return ajax.post('/aseapi/console/sysmgr/mouldmgr/deleteJsonMould', params)
    },

    getlistItem() {
        return ajax.get('/aseapi/console/sysmgr/mouldmgr/listItem')
    }
}
